import { Box, Button, Drawer, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import ExportPayoutReports from 'src/clinic/views/clinicBrandPayoutReports/components/ExportPayoutReports'
import ExportTypeSelector from 'src/clinic/views/clinicBrandPayoutReports/components/ExportTypeSelector'
import { EXPORT_TYPES } from 'src/clinic/views/clinicBrandPayoutReports/util'

export default function ExportPayoutReportsDialogWithButton({
  dataFetchingApiUrl,
  startDate,
  endDate,
  entityId,
  entityType,
  eventType,
  allEventTypes,
  fileNamePrefix,
  extraParams,
  payoutReportDataArrayToExcelFormatArrayBuilder,
  useLocalDateFormatForApiCalls = false,
  paymentConfig,
  periodOptions = [],
  practitionerContact,
}) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [exportDrawerOpen, setExportDrawerOpen] = useState(false)
  const [exportType, setExportType] = useState(EXPORT_TYPES.excel.id)
  const SupportSendIcon = EXPORT_TYPES.support_pdf.icon
  function handleSelectExportType(type) {
    setExportType(type)
    setExportDrawerOpen(true)
  }

  return (
    <>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        <ExportTypeSelector
          handleSelectExportType={handleSelectExportType}
          hideOptionsId={[
            EXPORT_TYPES.support_pdf.id,
            ...(entityType === 'mentor' ? [] : [EXPORT_TYPES.practitioner_pdf.id]),
          ]}
        />
        {entityType === 'mentor' && (
          <Button
            variant="outlined"
            startIcon={<SupportSendIcon />}
            onClick={() => handleSelectExportType(EXPORT_TYPES.support_pdf.id)}
          >
            Send to me
          </Button>
        )}
      </Box>
      <Drawer
        anchor={isMobile ? 'bottom' : 'right'}
        open={exportDrawerOpen}
        onClose={() => setExportDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: 640 },
            maxWidth: '100%',
            height: { xs: '92vh', sm: '100%' },
            borderTopLeftRadius: { xs: 8, sm: 0 },
            borderTopRightRadius: { xs: 8, sm: 0 },
          },
        }}
      >
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <ExportPayoutReports
          exportType={exportType}
          closeDialog={() => setExportDrawerOpen(false)}
          dataFetchingApiUrl={dataFetchingApiUrl}
          startDate={startDate}
          endDate={endDate}
          entityId={entityId}
          entityType={entityType}
          eventType={eventType}
          allEventTypes={allEventTypes}
          fileNamePrefix={fileNamePrefix}
          extraParams={extraParams}
          useLocalDateFormatForApiCalls={useLocalDateFormatForApiCalls}
          paymentConfig={paymentConfig}
          periodOptions={periodOptions}
          practitionerContact={practitionerContact}
          payoutReportDataArrayToExcelFormatArrayBuilder={
            payoutReportDataArrayToExcelFormatArrayBuilder
          }
        />
        </Box>
      </Drawer>
    </>
  )
}
